import { createIcon } from '../createIcon';
import { ReactComponent as IconGroup } from '../svg/group.svg';

export default createIcon(IconGroup);
